import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '../store'
import {getToken} from '@/utils/auth'
import i18n from "@/lang";

// 防止多个接口同时返回 401 时重复弹窗。
let isHandlingUnauthorized = false

const addInterceptors = (instance) => {
  // request拦截器
  instance.interceptors.request.use(config => {
    let token = getToken()
    // 请求头携带当前国际化语言
    config.headers['Accept-Language'] = localStorage.getItem('language-admin') === 'zh' ? 'zh-CN' : 'en'

    if (token) {
      config.headers['Authorization'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  }, error => {
    Promise.reject(error)
  })

  // respone拦截器
  instance.interceptors.response.use(
    response => {
      if (response && response.config && (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer')) {
        return response.data
      }
      // 处理文件流响应
      const contentType = response.headers['content-type']
      // 处理下载图片流响应
      if (
        (contentType && contentType.includes("application/octet-stream")) ||
        contentType.includes("application/pdf") ||
        contentType.includes("application/x-download")
      ) {
        return response.data;
      }

      let res = response.data

      // 401：未登录/token 过期
      if (res.code === 401) {
        // 其他页签已退出登录时，token 通常已被清除；交给 App.vue 的 storage 监听跳转，禁止再次弹窗。
        if (!getToken()) {
          return
        }

        // 多个接口同时返回 401 时，只显示一次弹窗。
        if (isHandlingUnauthorized) {
          return
        }
        isHandlingUnauthorized = true

        MessageBox.alert(i18n.t('system.loggedOut'), i18n.t('system.confirmLogout'), {
          confirmButtonText: i18n.t('button.confirm'),
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).catch(() => {
          // 弹窗被异常关闭时仍继续执行退出，避免停留在无权限页面。
        }).then(() => {
          return store.dispatch('LogOut')
        }).then(() => {
          // storage 事件不会通知当前页签，当前页需要主动跳转。
          window.location.hash = '#/login'
        }).finally(() => {
          isHandlingUnauthorized = false
        })
      } else if (res.code === 301) {
        Message({
          message: res.message,
          type: 'warning',
          duration: 3 * 1000
        })
        return response.data
      } else if (res.code === 500) {
        Message({
          message: res.message,
          type: 'warning',
          duration: 3 * 1000
        })
        return Promise.reject(new Error(res.message))
      } else if(res.code === 7901) {
        return response.data
      } else if (res.code !== 200 && res.code !== 7509) {
        const message = res.message
        if (!message) {
          Message({
            message: i18n.t('message.systemError'),
            type: 'warning',
            duration: 3 * 1000
          })
        } else {
          Message({
            message: message,
            type: 'error',
            duration: 3 * 1000
          })
          return response.data
        }
      }else {
        return response.data
      }
    },
    error => {
      // ========== 场景B：HTTP状态码429（网关限流）==========
      if (error.response && error.response.status === 429) {
        const resData = error.response.data || {}
        const msg = resData.message
        Message({
          message: msg,
          type: 'warning',
          duration: 3 * 1000
        })
      } else {
        Message({
          message: error.message,
          type: 'error',
          duration: 3 * 1000
        })
      }
      return Promise.reject(error)
    })
}


export const userService = 'srs-user-service'
export const productService = 'srs-product-service'
export const orderService = 'srs-order-service'
export const baseService = 'srs-base-data-service'
export const thirdPartService = 'srs-thirdparty-service'
export const paymentService = 'srs-payment-service'

export const userUrl = process.env.BASE_API + 'srs-user-service'
const productUrl = process.env.BASE_API + 'srs-product-service'
const orderUrl = process.env.BASE_API + 'srs-order-service'
const baseUrl = process.env.BASE_API + 'srs-base-data-service'
export const thirdPartUrl = process.env.BASE_API + 'srs-thirdparty-service'
const paymentUrl = process.env.BASE_API + 'srs-payment-service'
const messageUrl = process.env.BASE_API + 'srs-message-service'


// 上传文件
export const fileUpload = thirdPartUrl + '/obsFile/upload'

// 创建axios实例
const requestUser = axios.create({
  baseURL: userUrl,
  timeout: 30000
})

const requestProduct = axios.create({
  baseURL: productUrl,
  timeout: 30000
})

const requestOrder = axios.create({
  baseURL: orderUrl,
  timeout: 30000
})

const requestBase = axios.create({
  baseURL: baseUrl,
  timeout: 30000
})

const requestThirdPart = axios.create({
  baseURL: thirdPartUrl,
  timeout: 30000
})

const requestPayment = axios.create({
  baseURL: paymentUrl,
  timeout: 30000
})

const requestMessage = axios.create({
  baseURL: messageUrl,
  timeout: 30000
})

addInterceptors(requestUser)
addInterceptors(requestProduct)
addInterceptors(requestOrder)
addInterceptors(requestBase)
addInterceptors(requestThirdPart)
addInterceptors(requestPayment)
addInterceptors(requestMessage)

export {requestUser, requestProduct, requestOrder, requestBase, requestThirdPart, requestPayment, requestMessage}



// WEBPACK FOOTER //
// ./src/utils/request.js